/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
import React from 'react';
import clsx from 'clsx';
import {
  Popover,
  Box,
  Button,
  TextField,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import T from 'i18n-react';

import classes from './Filter.module.scss';

const Filter = ({
  options = [],
  selections = [],
  filterSearch,
  placeholder,
  renderLabel,
  onApply,
  onReset,
  filterIcon = <FilterListIcon />,
  disablePopover,
  containerClasses,
  multiple = true,
}) => {
  const ref = React.createRef();
  const isApplied = React.useRef(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [search, setSearch] = React.useState('');
  const [selected, setSelected] = React.useState(selections);

  React.useEffect(() => {
    const haveAllOption = options.some(({ value }) => value === '' || value === 'all');
    if (haveAllOption) {
      const newChecked = options.map(({ value: option }) => option);
      setSelected(newChecked);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setSearch('');

    if (selections.some((value) => !value)) {
      setSelected(options.map(({ value }) => value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  React.useEffect(() => {
    setSelected(selections.map((value) => value));
  }, [selections]);

  const handleToggle = (value) => () => {
    const currentIndex = selected.indexOf(value);
    const isSelectedAll = value === '';
    let newChecked = [...selected];

    if (currentIndex === -1) {
      if (isSelectedAll) {
        newChecked = options.map(({ value: option }) => option);
        setSelected(newChecked);
        return;
      }
      newChecked.push(value);
    } else {
      if (isSelectedAll) {
        newChecked.length = 0;
        setSelected(newChecked);
        return;
      }
      newChecked.splice(currentIndex, 1);
    }
    newChecked = newChecked.filter((option) => !!option);

    const haveAllOption = options.some(({ value }) => value === '' || value === 'all');
    if (newChecked.length === options.length - 1 && haveAllOption) {
      newChecked.push('');
    }
    setSelected(newChecked);
  };

  const handleSingleSelect = (value) => () => {
    setSelected([value]);
  };
  const renderContent = () => {
    return (
      <>
        {filterSearch && (
          <Box p={2}>
            <TextField
              className={classes.searchBox}
              variant="outlined"
              value={search}
              onChange={(event) => {
                setSearch(event.target.value);
              }}
              placeholder={placeholder}
            />
          </Box>
        )}

        <Box maxHeight="350px" overflow="auto">
          <List>
            {options
              .filter(({ label }) => label.toLowerCase().includes(search.toLowerCase()))
              .map(({ value, label }) => {
                return (
                  <ListItem
                    className={classes.item}
                    key={`${value}-${label}`}
                    dense
                    button
                    onClick={multiple ? handleToggle(value) : handleSingleSelect(value)}>
                    <ListItemIcon>
                      <Checkbox
                        indeterminate={
                          value === '' && selected.length > 0 && selected.length < options.length
                        }
                        edge="start"
                        checked={selected.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ 'aria-labelledby': value }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={label} />
                  </ListItem>
                );
              })}
          </List>
        </Box>
        <Box className={classes.footer}>
          <Button
            onClick={() => {
              setSearch('');
              setAnchorEl(null);
              setOpen(false);
              onApply && onApply(selected);
            }}
            className={classes.primary}
            variant="contained"
            color="primary">
            {T.translate('general.apply')}
          </Button>
          <Button
            onClick={() => {
              setSelected(selections);
              onReset && onReset();
            }}
            variant="outlined"
            color="default">
            {T.translate('general.reset')}
          </Button>
        </Box>
      </>
    );
  };
  return (
    <Box className={clsx(classes.wrapper, containerClasses)}>
      {!disablePopover ? (
        <>
          <Button
            disableRipple
            className={clsx(classes.button, { [classes.active]: open })}
            style={{ textTransform: 'none' }}
            onClick={(event) => {
              setAnchorEl(event.currentTarget);
              setOpen(true);
            }}
            ref={ref}
            startIcon={filterIcon}
            endIcon={!anchorEl ? <ExpandMoreIcon /> : <ExpandLessIcon />}>
            {renderLabel && renderLabel(selected)}
          </Button>

          <Popover
            PaperProps={{
              style: {
                width: 'auto',
              },
            }}
            onClose={() => {
              setSearch('');
              setAnchorEl(null);
              setOpen(false);
              if (!isApplied.current) {
                setSelected(selections);
              }
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}>
            {renderContent()}
          </Popover>
        </>
      ) : (
        renderContent()
      )}
    </Box>
  );
};

export default Filter;
